module.exports = __webpack_public_path__ + "img/VSO.ac6ebaaa.jpg";